import { useState, useEffect } from 'react';
import { Bike } from 'lucide-react';

export default function WeatherWidget() {
  const [weather, setWeather] = useState(null);
  const [loading, setLoading] = useState(true);
  const [recommendation, setRecommendation] = useState(null);
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    fetchWeather();
  }, []);

  const fetchWeather = async () => {
    try {
      const res = await fetch('https://wttr.in/San Jose, Costa Rica?format=j1');
      const data = await res.json();
      setWeather(data);
      analyzeWeather(data);
    } catch (err) {
      setRecommendation({ good: true, message: '☀️ Clima no disponible' });
    } finally {
      setLoading(false);
    }
  };

  const analyzeWeather = (data) => {
    const current = data.current_condition[0];
    const temp = parseInt(current.temp_C);
    const humidity = parseInt(current.humidity);
    const chanceRain = parseInt(current.precipMM) > 0 ? 80 : parseInt(current.chanceofrain || 0);
    const windspeed = parseInt(current.windspeedKm);

    const isStormy = current.weatherCode.includes('Thunder') || windspeed > 40;
    const isRainy = chanceRain > 50 || current.weatherCode.includes('Rain');
    const isWindy = windspeed > 35;
    const isHot = temp > 38;
    const isCold = temp < 18;

    if (isStormy) {
      setRecommendation({ good: false, icon: '⛈️', message: '¡Tormenta! Mejor espera' });
    } else if (isRainy && humidity > 85) {
      setRecommendation({ good: false, icon: '🌧️', message: 'Lluvia fuerte, lleva capa' });
    } else if (isWindy) {
      setRecommendation({ good: false, icon: '💨', message: 'Muy ventoso, precaución' });
    } else if (isHot) {
      setRecommendation({ good: true, icon: '🔥', message: `${temp}°C - Hidrátate bien` });
    } else if (isCold) {
      setRecommendation({ good: true, icon: '🥶', message: `${temp}°C - Abrígate` });
    } else if (isRainy || chanceRain > 30) {
      setRecommendation({ good: true, icon: '🌦️', message: 'Posible lluvia, lleva capa' });
    } else {
      setRecommendation({ good: true, icon: '🏍️', message: '¡Buen día para moto!' });
    }
  };

  if (loading) return null;

  const temp = weather ? parseInt(weather.current_condition[0].temp_C) : null;
  const humidity = weather ? parseInt(weather.current_condition[0].humidity) : null;

  return (
    <div className="bg-black/40 backdrop-blur-sm border border-white/20 rounded-xl p-4 text-white text-center min-w-[100px]">
      <div className="text-5xl mb-1">{recommendation?.icon || '🏍️'}</div>
      {temp !== null && <div className="text-2xl font-black">{temp}°</div>}
      {humidity !== null && <div className="text-xl">💧{humidity}%</div>}
    </div>
  );
}